import { useState } from 'react';
import { useWorkspaceStore } from '@/store/workspaceStore';
import { SectionCard } from '@/components/SectionCard';
import { Button } from '@/components/Button';
import { ConfirmDialog } from '@/components/Modal';
import type { ReelProject } from '@/types';

export function ProjectSettingsPanel({ project }: { project: ReelProject }) {
  const renameProject = useWorkspaceStore((s) => s.renameProject);
  const duplicateProject = useWorkspaceStore((s) => s.duplicateProject);
  const deleteProject = useWorkspaceStore((s) => s.deleteProject);
  const exportProjectJson = useWorkspaceStore((s) => s.exportProjectJson);
  const [confirmDelete, setConfirmDelete] = useState(false);

  function handleExportJson() {
    const json = exportProjectJson(project.id);
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${project.title}.json`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  return (
    <div className="space-y-4">
      <SectionCard title="Reel details">
        <label className="block">
          <span className="mb-1 block text-xs font-medium text-slate-600 dark:text-slate-300">Title</span>
          <input
            value={project.title}
            onChange={(e) => renameProject(project.id, e.target.value)}
            className="w-full rounded-md border border-slate-300 px-2 py-1.5 text-sm dark:border-slate-600 dark:bg-slate-800"
          />
        </label>
        <p className="text-xs text-slate-400">
          Created {new Date(project.createdAt).toLocaleString()} · Last updated {new Date(project.updatedAt).toLocaleString()}
        </p>
        <p className="text-xs text-slate-400">{project.images.length} image(s) in sequence.</p>
      </SectionCard>

      <SectionCard title="Actions">
        <div className="flex flex-wrap gap-2">
          <Button size="sm" onClick={() => duplicateProject(project.id)}>
            Duplicate Reel
          </Button>
          <Button size="sm" onClick={handleExportJson}>
            Export as JSON
          </Button>
          <Button size="sm" variant="danger" onClick={() => setConfirmDelete(true)}>
            Delete Reel
          </Button>
        </div>
      </SectionCard>

      <ConfirmDialog
        open={confirmDelete}
        title="Delete this Reel?"
        message="This permanently removes the Reel and its settings from this device. This cannot be undone."
        onCancel={() => setConfirmDelete(false)}
        onConfirm={() => {
          deleteProject(project.id);
          setConfirmDelete(false);
        }}
      />
    </div>
  );
}
